import { Typography, useTheme } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

export type PopoverItem = {
  id: string
  label: string
  value: string
  isOffline?: boolean
  Icon: React.ReactNode
}
interface Props {
  items: PopoverItem[]
}

const useStyles = makeStyles()(theme => ({
  popoverWrapper: {
    backgroundColor: theme.palette.shades.shade04,
    padding: theme.spacing(2),
    borderSpacing: '5px',
  },
}))

/*
 * This component is used to display the popover items in the live view
 */
const PopoverItems: React.FC<Props> = ({ items }) => {
  const theme = useTheme()
  const { classes } = useStyles()

  return (
    <table className={classes.popoverWrapper}>
      {items.map(({ id, label, value, Icon, isOffline }, index) => (
        <tr key={`${id}_${index}`}>
          <td>
            <Typography color={isOffline ? theme.palette.grey.grey03 : undefined}>{index + 1}</Typography>
          </td>
          <td>
            <Typography sx={{ marginBottom: -1 }}>{Icon}</Typography>
          </td>
          <td>
            <Typography color={isOffline ? theme.palette.grey.grey03 : undefined}>{label}</Typography>
          </td>
          <td>
            <Typography sx={{ display: 'flex', justifyContent: 'flex-end' }}>{value}</Typography>
          </td>
        </tr>
      ))}
    </table>
  )
}

export default PopoverItems
